import { createEvent, restore, sample } from '@lib/state-engine';

export const selectSleeveWarehouse = createEvent();
export const selectStationaryWarehouse = createEvent();
export const toggleOpenDropdown = createEvent<boolean>();

export const $dropdownOpened = restore(toggleOpenDropdown, false);

sample({
  clock: [selectSleeveWarehouse, selectStationaryWarehouse],
  fn: () => false,
  target: toggleOpenDropdown,
});
